const PrivacyPolicySection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            <div className="col-lg-12">
              <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                <div className="about__content-inner">
                  <p className="text-justify">
                    Asiatic Stock & Securities LTD is strongly committed to every individual's right to privacy and to
                    keeping personal and financial information secure. As part of the effort to earn your trust and
                    confidence in our commitment, we are fully disclosing our privacy practices. We therefore encourage
                    you to read our privacy statement to familiarize and understand the types of personally identifiable
                    information we collect and how we use this information.
                  </p>
                  
                  <h4>policy regarding use of information collected by asiatic stock & securities ltd</h4>
                  <p className="text-justify">
                    Asiatic Stock & Securities LTD only collects the necessary personally
                    identifiable information in order to respond to your requests for our customized products and
                    services. Personally identifiable information is defined as any information that identifies or can be
                    used to identify, contact, or locate the person to whom such information pertains. Such information
                    pertinent to the site includes, but is not limited to, first and last name, physical address, e-mail
                    address, phone number, birth date, and any other information that itself identifies or when tied to
                    the above information, may identify you as a specific individual.
                  </p>

                  <p className="text-justify">
                    Asiatic Stock & Securities LTD only collects personally identifiable information about you when you
                    specifically and knowingly provide it. The site collects your information in order to record and
                    support your participation in the activities you select. If you subscribe to a service or register a
                    product, for example, the information is used to register your rights, if any, to technical support or
                    other benefits that may be made available to registered users. Asiatic Stock & Securities LTD and its
                    service partners use your personally identifiable information to operate the sites and services and to
                    inform you of new features, services, and products from Asiatic Stock & Securities LTD and its
                    affiliates.
                  </p>
                  
                  <p className="text-justify">
                    Asiatic Stock & Securities LTD may also carefully select other companies to send you information about
                    their products or services which are related to the site's service but are not necessary to its
                    operation (an "Extended Service"). If Asiatic Stock & Securities LTD intends to use personally
                    identifiable information for an Extended Service, the Asiatic Stock & Securities LTD site will also
                    provide you with the ability and requisite instructions to decline this service. You may also stop the
                    delivery of informational or promotional mail from Asiatic Stock & Securities LTD by following the
                    instructions on the mail.
                  </p>
                  
                  <p className="text-justify">
                    Asiatic Stock & Securities LTD may disclose personally identifiable information
                    if required to do so by law or in the good-faith belief that such action is necessary to:
                  </p>
                  
                  <p><b>Conform to the edicts of the law or comply with legal process served on the site or its owners;</b></p>
                  <p><b>Protect and defend the rights or property of the site-owners or the site, and</b></p>
                  <p><b>Act under exigent circumstances to protect the personal safety of users of Smart , the site, its owners, or the public.</b></p>
                  
                  <h4>protection of your personally identifiable information</h4>
                  <p>
                    The personal information that you provide in connection with registering yourself as a user of
                    Asiatic Stock & Securities LTD products or services is classified as Registration Information.
                    Registration Information is protected in several ways. Access by you to your Registration Information
                    is available through a password and unique customer ID selected by you. This password is encrypted. We
                    recommend that you do not divulge your password to anyone. In addition, your Registration Information
                    resides on a secure server that only selected Asiatic Stock & Securities LTD personnel and contractors
                    have access to via password. We also encrypt your personal information and thereby strive to prevent
                    unauthorized parties from viewing such information when it is transmitted to www.smartequity.in.
                  </p>
                  
                  <h4>User/member Interaction Features</h4>
                  <p>
                    Asiatic Stock & Securities LTD has many features that provide for users/members to disclose their
                    identities and communicate with other users/members. Your use of such features and disclosure of any
                    personal details (e.g. e-mail address) by you through these features are at your sole risk and Asiatic
                    Stock & Securities LTD accepts no responsibility for the same. However, if your privacy has been
                    intruded as a result of participating in such features, you could notify us by e-mail at: <a
                    href="mailto:info@asiaticstock.in">info@asiaticstock.in</a>
                  </p>
                  
                  <h6>Other Websites</h6>
                  <p>
                    The Asiatic Stock & Securities LTD site contains links to other websites. Asiatic Stock & Securities
                    LTD is not responsible for the privacy practices or the content of such websites.
                  </p>
                  
                  <h4>Notify Us</h4>
                  <p>
                    If at any time you become aware of the fact or believe that Asiatic Stock &amp; Securities LTD or its
                    users/members have not adhered to these principles, please notify Asiatic Stock &amp; Securities LTD
                    Commodity Brokers by e-mail at: <a href="mailto:info@asiaticstock.in">info@asiaticstock.in</a> and we will
                    use all commercially reasonable efforts to promptly determine and correct the problem.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicySection;